<template>
  <div class="loader loader--style2">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
    <path fill="#000" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
      <animateTransform attributeType="xml"
        attributeName="transform"
        type="rotate"
        from="0 25 25"
        to="360 25 25"
        dur="0.6s"
        repeatCount="indefinite"/>
      </path>
    </svg>
  </div>
</template>

<style lang="scss">
  .loader{
    width: 100%;
    height: 100vh;
    text-align: center;
    padding: 1em;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    z-index: 99999;
    top:0;
    left:0;
    background: rgba(204,204,204,0.5)
  }

  .loader svg {
      vertical-align: middle;
       path {
          fill: var(--solar-calc-primary-color);
      }
  }


</style>

<script>
  //import RadialProgressBar from 'vue-radial-progress';
  export default {
    name: 'LoadingOverlay',
    props: {
    },
    components: {
        //RadialProgressBar
    },
    data () {
      return {}
    },
  }
</script>
